import Header from "@/components/header";
import { CustomLink } from "@/styles/shared/link/link.style";
import { ActionIcon, NavLink, Stack } from "@mantine/core";
import {
  IconAddressBook,
  IconAlignBoxRightMiddle,
  IconMessage,
  IconUserStar,
} from "@tabler/icons-react";

const Setting = () => {
  // const platform = localStorage.getItem("platform");

  return (
    <>
      <Stack h="100svh">
        <Stack>
          <Header showHome showBack title="تنظیمات" route="/dashboard" />
        </Stack>
        <Stack px="md">
          <CustomLink
            to="/dashboard/profile/template"
            style={{ textDecoration: "none" }}
          >
            <NavLink
              label="قالب های من"
              color="gray"
              leftSection={
                <ActionIcon variant="subtle" c="gray">
                  <IconAlignBoxRightMiddle />
                </ActionIcon>
              }
            />
          </CustomLink>
          <CustomLink
            to="/dashboard/profile/customerGroup"
            style={{ textDecoration: "none" }}
          >
            <NavLink
              label="گروه های پیامکی"
              color="gray"
              leftSection={
                <ActionIcon variant="subtle" c="gray">
                  <IconUserStar />
                </ActionIcon>
              }
            />
          </CustomLink>

          <CustomLink
            to="/dashboard/profile/importContact"
            style={{ textDecoration: "none" }}
          >
            <NavLink
              label="افزودن مخاطبین از تلفن همراه"
              color="gray"
              leftSection={
                <ActionIcon variant="subtle" c="gray">
                  <IconAddressBook />
                </ActionIcon>
              }
            />
          </CustomLink>

          <CustomLink
            to="/dashboard/profile/autoMessage"
            style={{ textDecoration: "none" }}
          >
            <NavLink
              label="پیامک های خودکار"
              color="gray"
              leftSection={
                <ActionIcon variant="subtle" c="gray">
                  <IconMessage />
                </ActionIcon>
              }
            />
          </CustomLink>
        </Stack>
      </Stack>
    </>
  );
};

export default Setting;
